import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-slate-50 px-6 py-5" }
const _hoisted_2 = { class: "mx-auto max-w-7xl space-y-4" }
const _hoisted_3 = { class: "flex items-center gap-2 text-sm" }
const _hoisted_4 = { class: "rounded-md border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_5 = { class: "text-2xl font-semibold text-slate-950" }
const _hoisted_6 = { class: "mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-600" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "grid gap-5 lg:grid-cols-[minmax(0,1fr)_360px]" }
const _hoisted_11 = { class: "rounded-md border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "space-y-4" }
const _hoisted_15 = { class: "rounded-md border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_16 = {
  key: 0,
  class: "mt-4 space-y-3"
}
const _hoisted_17 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_18 = { class: "block" }
const _hoisted_19 = { class: "block" }
const _hoisted_20 = { class: "block" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "block"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "mt-4 space-y-3" }
const _hoisted_25 = { class: "flex items-start justify-between gap-3" }
const _hoisted_26 = { class: "text-sm font-semibold text-slate-900" }
const _hoisted_27 = { class: "shrink-0 text-xs text-slate-500" }
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "rounded-md border border-slate-200 bg-white p-4 shadow-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CancelReturn = _resolveComponent("CancelReturn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "text-brand-600 hover:text-brand-800"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("Back to jobs")
          ])),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-slate-300" }, "/", -1)),
        _createVNode(_component_router_link, {
          to: `/edit/${$setup.job.id}`,
          class: "text-brand-600 hover:text-brand-800"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("Edit")
          ])),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.job.title), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-medium text-slate-800" }, "Company:", -1)),
            _createTextVNode(" " + _toDisplayString($setup.job.company), 1)
          ]),
          ($setup.job.salary_range)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-medium text-slate-800" }, "Salary:", -1)),
                _createTextVNode(" " + _toDisplayString($setup.job.salary_range), 1)
              ]))
            : _createCommentVNode("", true),
          ($setup.job.job_url)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-medium text-slate-800" }, "URL:", -1)),
                _createElementVNode("a", {
                  href: $setup.job.job_url,
                  target: "_blank",
                  class: "text-brand-600 hover:text-brand-800"
                }, _toDisplayString($setup.domainName), 9, _hoisted_9)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("main", _hoisted_11, [
          _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-lg font-semibold text-slate-950" }, "Job Description", -1)),
          _createElementVNode("div", {
            innerHTML: $setup.processedDescription,
            class: "mt-4 max-w-none rounded-md border border-slate-200 bg-white p-4 text-sm leading-6 text-slate-700"
          }, null, 8, _hoisted_12),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_CancelReturn, {
              text: "Return",
              onCancel: $setup.cancel
            }, null, 8, ["onCancel"])
          ])
        ]),
        _createElementVNode("aside", _hoisted_14, [
          _createElementVNode("section", _hoisted_15, [
            _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "text-lg font-semibold text-slate-950" }, "Application Status", -1)),
            ($setup.job.latest_process_type !== 'Rejected')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-xs font-medium text-slate-500" }, "Date", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.statusDate) = $event)),
                        type: "date",
                        class: "mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                      }, null, 512), [
                        [_vModelText, $setup.statusDate]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_19, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-xs font-medium text-slate-500" }, "Time", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.statusTime) = $event)),
                        type: "time",
                        class: "mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                      }, null, 512), [
                        [_vModelText, $setup.statusTime]
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_20, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-xs font-medium text-slate-500" }, "Status", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedStatus) = $event)),
                      class: "mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                    }, [
                      _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "Add status", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statuses, (status) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: status,
                          value: status
                        }, _toDisplayString(status), 9, _hoisted_21))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, $setup.selectedStatus]
                    ])
                  ]),
                  ($setup.isInterviewStatus($setup.selectedStatus))
                    ? (_openBlock(), _createElementBlock("label", _hoisted_22, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-xs font-medium text-slate-500" }, "Interview notes", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.statusNotes) = $event)),
                          rows: "3",
                          placeholder: "Prep notes, interviewer names, follow-up items...",
                          class: "mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                        }, null, 512), [
                          [_vModelText, $setup.statusNotes]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.updateStatus && $setup.updateStatus(...args))),
                    disabled: !$setup.selectedStatus,
                    class: "w-full rounded-md bg-brand-600 px-3 py-2 text-sm font-medium text-white hover:bg-brand-700 disabled:cursor-not-allowed disabled:bg-slate-300"
                  }, " Add Status ", 8, _hoisted_23)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.processSteps, (process) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: process.id,
                  class: "rounded-md border border-slate-200 bg-slate-50 p-3"
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(process.process_type), 1),
                    _createElementVNode("span", _hoisted_27, _toDisplayString($setup.formatProcessDateTime(process)), 1)
                  ]),
                  ($setup.isInterviewStatus(process.process_type))
                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                        key: 0,
                        "onUpdate:modelValue": ($event: any) => ((process.notes) = $event),
                        rows: "2",
                        placeholder: "Interview notes...",
                        class: "mt-2 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-xs focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                      }, null, 8, _hoisted_28)), [
                        [_vModelText, process.notes]
                      ])
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("section", _hoisted_29, [
            _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "text-lg font-semibold text-slate-950" }, "General Notes", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.generalNotes) = $event)),
              rows: "9",
              placeholder: "Overall thoughts, compensation notes, recruiter context, follow-up reminders...",
              class: "mt-3 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
            }, null, 512), [
              [_vModelText, $setup.generalNotes]
            ])
          ])
        ])
      ])
    ])
  ]))
}